import React from 'react';
import theme from '../config/theme';

interface LoadingScreenProps {
  text?: string;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ text = 'Loading...' }) => (
  <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: theme.colors.background }}>
    <div className="text-xl" style={{ color: theme.colors.text.secondary }}>{text}</div>
  </div>
);

export default LoadingScreen;
